<template>
  <main class="ws-page">
    <header class="ws-page-header">
      <h1
        class="ws-page-header__title has-text-weight-bold is-size-2"
        v-text="$t('Демонстрационные экзамены и экзаменационные группы')"
      ></h1>
      <div class="ws-page-header-actions">
        <ws-permission-node
          :resources="['services/de/demoexam']"
          :actions="['create']"
          effect="display"
        >
          <ws-role-node :only="['front_mio', 'front_50plus']">
            <button
              class="ws-button button is-text"
              @click="editExam"
            >
              <ws-icon
                class="ws-button__icon is-position-left"
                name="plus-circle"
                :title="$t('Добавить новый экзамен')"
                color="#1c3b8d"
                width="20"
                height="20"
              />
              <strong
                class="ws-button__text has-text-primary"
                v-text="$t('Добавить новый экзамен')"
              ></strong>
            </button>
          </ws-role-node>
          <ws-role-node :except="['front_mio', 'front_50plus']">
            <button
              class="ws-button button is-text"
              @click="editItem(true)"
            >
              <ws-icon
                class="ws-button__icon is-position-left"
                name="plus-circle"
                :title="$t('Создать заявку ФГОС')"
                color="#1c3b8d"
                width="20"
                height="20"
              />
              <strong class="ws-button__text has-text-primary">{{$t('Создать заявку на ДЭ')}}   </strong>
            </button>

          </ws-role-node>
        </ws-permission-node>
      </div>
    </header>
    <ws-demo-exams-list ref="examsList" />
  </main>
</template>

<script>
import WsRequestExamsForm from '@/components/de/request-exams/modals/WsRequestExamsForm'
import WsExamsForm from '@/components/de/demo-exams/modals/WsExamsForm'
export default {
  name: 'DemoExams',
  methods: {
    editItem (isFgos) {
      this.$buefy.modal.open({
        parent: this,
        component: WsRequestExamsForm,
        hasModalCard: true,
        canCancel: false,
        props: {
          fgos: isFgos
        },
        events: {
          'editExam': async exam => {
            await this.$refs.examsList._fetch()
          }
        }
      })
    },
    editExam () {
      this.$buefy.modal.open({
        parent: this,
        component: WsExamsForm,
        hasModalCard: true,
        canCancel: false,
        events: {
          'editExam': async exam => {
            await this.$refs.examsList._fetch()
          }
        }
      })
    }
  }
}
</script>
